export const METHODS_TO_VERIFY = [
  "wc_sessionPropose",
  "wc_sessionRequest",
  "wc_authRequest",
  "wc_sessionAuthenticate",
];
